export default __webpack_public_path__ + "static/media/bb10.0165b594.webp";